import script from "./IAConfiguracoesRelatorio.vue?vue&type=script&setup=true&lang=js"
export * from "./IAConfiguracoesRelatorio.vue?vue&type=script&setup=true&lang=js"

import "./IAConfiguracoesRelatorio.vue?vue&type=style&index=0&id=005f61e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005f61e8"]])

export default __exports__